import { getI18n } from 'react-i18next';

export const VALIDATION_HOLIDAY_EMPTY_HOLIDAY_YEAR = 'validation.holiday.emptyHolidayYear';
export const VALIDATION_HOLIDAY_HOLIDAY_YEAR_IN_PAST = 'validation.holiday.holidayYearInPast';
export const VALIDATION_HOLIDAY_HOLIDAY_YEAR_ALREADY_EXISTS = 'validation.holiday.holidayYearAlreadyExists';
export const VALIDATION_HOLIDAY_EMPTY_HOLIDAYS = 'validation.holiday.emptyHolidays';
export const VALIDATION_HOLIDAY_EMPTY_HOLIDAY = 'validation.holiday.emptyHoliday';
export const VALIDATION_HOLIDAY_EMPTY_NAME = 'validation.holiday.emptyName';
export const VALIDATION_HOLIDAY_INVALID_NAME_LENGTH = 'validation.holiday.invalidNameLength';
export const VALIDATION_HOLIDAY_EMPTY_HOLIDAY_DATE = 'validation.holiday.emptyHolidayDate';
export const VALIDATION_HOLIDAY_INVALID_HOLIDAY_DATE = 'validation.holiday.invalidHolidayDate';
export const VALIDATION_HOLIDAY_HOLIDAY_DATE_NOT_UNIQUE = 'validation.holiday.holidayDateNotUnique';
export const VALIDATION_HOLIDAY_HOLIDAY_YEAR_NOT_EXISTS = 'validation.holiday.holidayYearDoesNotExist';

export const createHolidayErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_HOLIDAY_EMPTY_HOLIDAY_YEAR:
            result = i18n.t('holidays.error.holiday-empty-year');
            break;
        case VALIDATION_HOLIDAY_HOLIDAY_YEAR_IN_PAST:
            result = i18n.t('holidays.error.holiday-year-in-past');
            break;
        case VALIDATION_HOLIDAY_HOLIDAY_YEAR_ALREADY_EXISTS:
            result = i18n.t('holidays.error.holiday-year-already-exists');
            break;
        case VALIDATION_HOLIDAY_EMPTY_HOLIDAYS:
            result = i18n.t('holidays.error.holiday-empty-holidays');
            break;
        case VALIDATION_HOLIDAY_EMPTY_HOLIDAY:
            result = i18n.t('holidays.error.holiday-empty-holiday');
            break;
        case VALIDATION_HOLIDAY_EMPTY_NAME:
            result = i18n.t('holidays.error.holiday-empty-name');
            break;
        case VALIDATION_HOLIDAY_INVALID_NAME_LENGTH:
            result = i18n.t('holidays.error.holiday-invalid-name-length', { maxLetters: params[0] });
            break;
        case VALIDATION_HOLIDAY_EMPTY_HOLIDAY_DATE:
            result = i18n.t('holidays.error.holiday-empty-holiday-date');
            break;
        case VALIDATION_HOLIDAY_INVALID_HOLIDAY_DATE:
            result = i18n.t('holidays.error.holiday-invalid-holiday-date');
            break;
        case VALIDATION_HOLIDAY_HOLIDAY_DATE_NOT_UNIQUE:
            result = i18n.t('holidays.error.holiday-date-not-unique');
            break;
        case VALIDATION_HOLIDAY_HOLIDAY_YEAR_NOT_EXISTS:
            result = i18n.t('holidays.error.holiday-year-not-exists');
            break;
        default:
            result = undefined;
    }
    return result;
};
